module.exports = __webpack_public_path__ + "img/chris.df6fb760.svg";